
const Cookies = {
    setSession: function (sessionId) {
        this.setCookie('session_id', sessionId)
    },
    setCookie: function (name, value, options = {}) {

        options = {
            path: '/',
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    },
    getCookie: function(name) {
        let matches = document.cookie.match(new RegExp(
            //"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
            "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    getSession: function() {
        return this.getCookie('session_id');
    },
    deleteSession: function () {
        this.deleteCookie('session_id');
    },
    deleteCookie: function(name) {
        this.setCookie(name, "", {
            'max-age': -1
        })
    }
};

export default Cookies;